// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.no-rights[data-v-58ce6088] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  max-width: 550px;\n  min-height: 65vh;\n  margin: 0 auto;\n  font-size: 18px;\n  text-align: center;\n}\n.no-rights__text[data-v-58ce6088] {\n  display: block;\n  width: 100%;\n  margin: 0;\n}\n.no-rights__text ~ .no-rights__text[data-v-58ce6088] {\n  margin-top: 15px;\n}\n", ""]);
// Exports
module.exports = exports;
